export const environment = {
    version: 'v2.0.0 build 2',
    production: false,
    //baseUrl: 'https://localhost:7251/'
    baseUrl: 'https://dev-api.dhabi.com/'
};
